import * as React from 'react'
import * as LodashFP from 'lodash/fp'

import { Box } from '@design/pt-ui'
import CreativeStatusIcon from '../components/CreativeStatusIcon'

import { Project } from '../interfaces/entities/project'
import { IStringTMap } from '../types/map'
import { Labeled } from '../interfaces/base'

interface ICreativeStatuses {
  project: Project
  states: Labeled[]
}

function countCreativeStatuses(
  project: Project,
  initialStatuses: IStringTMap<{ count: number; label: string }> = {},
) {
  const statuses: IStringTMap<{
    count: number
    label: string
  }> = LodashFP.cloneDeep(initialStatuses || {})

  for (const formatset of project.formatsets) {
    for (const creative of formatset.creatives) {
      if (creative.status.name in statuses) {
        statuses[creative.status.name].count += 1
      } else {
        statuses[creative.status.name] = {
          count: 1,
          label: creative.status.label,
        }
      }
    }
  }
  return statuses
}

function CreativeStatuses(props: ICreativeStatuses) {
  const getStateLabel = (name: string) => {
    const state = props.states.find((s) => s.name === name)

    if (state) {
      return state.label
    } else {
      return name
    }
  }

  const project = props.project
  const statuses = countCreativeStatuses(project)
  const statusKeys = LodashFP.uniq([
    ...props.states.map((s) => s.name),
    ...Object.keys(statuses),
  ])

  return (
    <Box
      sx={{
        display: 'flex',
        flexFlow: 'row',
        alignItems: 'center',
        textAlign: 'right',
        paddingTop: 1,
        paddingBottom: 2,
        flexWrap: 'wrap',
      }}>
      {statusKeys.map((status) => (
        <div
          key={status}
          style={{
            display: 'flex',
            padding: '10px 0 10px 10px',
            alignItems: 'center',
          }}>
          <CreativeStatusIcon
            status={{
              name: status,
              label: getStateLabel(status),
            }}
          />
          <p style={{ padding: '5px', margin: 0 }}>
            {LodashFP.getOr(0, [status, 'count'], statuses)}
          </p>
        </div>
      ))}
    </Box>
  )
}

export default CreativeStatuses
